// import { AuthPayload } from "@/interfaces/ui.interface"

export default {
  setResult(state: any, payload: any) {
    state.result = payload
  },
  setTiposEvento(state: any, payload: any) {
    state.TiposEvento = payload
  },
  setCatalogo(state: any, payload: any) {
    state.Catalogo = payload
  },
  setOpcionesCotizacionList(state: any, payload: any) {
    state.OpcionesCotizacionList = payload
    state.totalItems = payload?.data.total
    state.page = payload?.data.page
    state.limit = payload?.data.limit
  },
  setOpcionCotizacionDetails(state: any, payload: any) {
    state.OpcionCotizacionDetails = payload
  },
  setCotizaciones(state: any, payload: any) {
    state.CotizacionesList = payload
    state.totalItems = payload?.data.total
    state.page = payload?.data.page
    state.limit = payload?.data.limit
  },
  setCotizacion(state: any, payload: any) {
    state.Cotizacion = payload
  },  
}